<nz-spin [nzSpinning]="loading$ | async">
  <nz-alert nzType="info" [nzMessage]="alertContent">
    <ng-template #alertContent>
      <div
        [innerHTML]="
          'LOT_WATCH_REQUEST_BUY_MODAL.ALERT_MESSAGE' | translate: { price: price$ | async | number }
        "
      ></div>
      <br />
      <div [innerHTML]="'LOT_WATCH_REQUEST_BUY_MODAL.ALERT_END_LINE' | translate"></div>
    </ng-template>
  </nz-alert>
</nz-spin>

<ng-container *nzModalFooter>
  <button
    nz-button
    nzType="primary"
    [nzLoading]="creating$ | async"
    (click)="buyLotWatchRequest()"
  >
    {{ 'LOT_WATCH_REQUEST_BUY_MODAL.BUY' | translate }}
  </button>
  <button nz-button (click)="close()">
    {{ 'CANCEL' | translate }}
  </button>
</ng-container>
